import api from './api';
import { UserResponse } from './users';

export interface Site {
  id: string;
  name: string;
  address?: string;
  latitude?: number;
  longitude?: number;
  description?: string;
  /** Optional organisation this site belongs to. */
  organisationId?: string | null;
  /** Optional branding record linked to this site. */
  brandingId?: string | null;
  /** Local HH:MM (24h). Present for super_user and site_admin only. */
  curfewStart?: string | null;
  curfewEnd?: string | null;
  /** IANA timezone for site-local scheduling (e.g. Australia/Adelaide). */
  timezone?: string | null;
  createdAt: string;
  updatedAt: string;
}

export const sitesApi = {
  getAll: async (): Promise<Site[]> => {
    const { data } = await api.get('/sites');
    return data;
  },

  getMySites: async (): Promise<Site[]> => {
    const { data } = await api.get('/sites/my-sites');
    return data;
  },

  getById: async (id: string): Promise<Site> => {
    const { data } = await api.get(`/sites/${id}`);
    return data;
  },

  create: async (site: Partial<Site>): Promise<Site> => {
    const { data } = await api.post('/sites', site);
    return data;
  },

  update: async (id: string, site: Partial<Site>): Promise<Site> => {
    const { data } = await api.put(`/sites/${id}`, site);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/sites/${id}`);
  },

  getUsers: async (id: string): Promise<UserResponse[]> => {
    const { data } = await api.get(`/sites/${id}/users`);
    return data;
  },

  assignUser: async (siteId: string, userId: string): Promise<void> => {
    await api.post(`/sites/${siteId}/users`, { userId });
  },

  removeUser: async (siteId: string, userId: string): Promise<void> => {
    await api.delete(`/sites/${siteId}/users/${userId}`);
  },
};

